import React, { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

/** DSP-1 §2 — Linear 3-week: 21 days visible at 1440 px (grid-cols-21, min 56px per day; narrower screens scroll). */
const iso = (d) => d.toISOString().slice(0, 10);
export default function DispatchLinear({ grouping }) {
  const [mobs, setMobs] = useState([]);
  const [projects, setProjects] = useState({});
  const start = useMemo(() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; }, []);
  const days = useMemo(() => Array.from({ length: 21 }, (_, i) => { const d = new Date(start); d.setDate(d.getDate() + i); return d; }), [start]);
  useEffect(() => {
    Promise.all([api.get("/mobilizations"), api.get("/projects")]).then(([m, p]) => {
      const byId = Object.fromEntries((p.data || []).map((x) => [x.id, x]));
      const end = iso(days[20]);
      setMobs((m.data || []).filter((x) => byId[x.project_id] && ["scheduled", "ready_to_dispatch", "dispatched"].includes(x.status) && x.scheduled_start_date && x.scheduled_start_date <= end && (x.scheduled_end_date || x.scheduled_start_date) >= iso(days[0])));
      setProjects(byId);
    }).catch(() => {});
  }, [days]);
  const groups = useMemo(() => {
    const g = {};
    for (const m of mobs) {
      const k = grouping === "scope" ? (m.scope_code || m.scope_type || "No scope") : grouping === "skills" ? (m.scope_code || m.scope_type || "No scope") : (projects[m.project_id]?.project_name || "Unknown");
      (g[k] = g[k] || []).push(m);
    }
    return Object.entries(g).sort();
  }, [mobs, grouping, projects]);
  const col = (d) => Math.max(0, Math.min(20, Math.round((new Date(`${d}T00:00:00`) - start) / 86400000)));
  return (
    <div className="overflow-x-auto" data-testid="dispatch-linear">
      <div className="min-w-[1176px]">
        <div className="grid border-b border-border text-[10px] text-muted-foreground" style={{ gridTemplateColumns: "180px repeat(21, minmax(44px, 1fr))" }}>
          <div className="px-2 py-1">{grouping === "crew" ? "Job" : "Scope"}</div>
          {days.map((d) => <div key={iso(d)} className={`px-1 py-1 text-center ${[0, 6].includes(d.getDay()) ? "bg-muted/40" : ""}`} data-testid={`linear-day-${iso(d)}`}>{d.getMonth() + 1}/{d.getDate()}</div>)}
        </div>
        {groups.length === 0 && <div className="text-xs text-muted-foreground p-4 text-center" data-testid="linear-empty">Nothing dispatched or ready in the next 21 days.</div>}
        {groups.map(([k, list]) => (
          <div key={k} className="grid border-b border-border items-center" style={{ gridTemplateColumns: "180px repeat(21, minmax(44px, 1fr))" }} data-testid={`linear-row-${k}`}>
            <div className="px-2 py-2 text-xs font-medium text-foreground truncate">{k}<span className="text-muted-foreground font-normal"> · {list.length}</span></div>
            <div className="col-span-21 relative h-8" style={{ gridColumn: "2 / span 21" }}>
              {list.map((m, i) => {
                const a = col(m.scheduled_start_date), b = col(m.scheduled_end_date || m.scheduled_start_date);
                return (
                  <div key={m.id} data-testid={`linear-bar-${m.id}`} title={`${projects[m.project_id]?.project_name || ""} · ${m.scope_code || m.scope_type} · ${m.scheduled_start_date} → ${m.scheduled_end_date || m.scheduled_start_date} · ${m.status}`}
                       className={`absolute h-5 rounded text-[10px] px-1 truncate text-background ${m.status === "dispatched" ? "bg-foreground" : "bg-foreground/60"}`}
                       style={{ left: `${(a / 21) * 100}%`, width: `${((b - a + 1) / 21) * 100}%`, top: `${(i % 2) * 14 + 2}px` }}>
                    {m.scope_code || m.scope_type} {projects[m.project_id]?.job_number || ""}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
